import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { NotificationPreviewListItem } from './NotificationPreviewListItem';

export class NotificationPreviewList extends React.Component {

    render() {
        const {
            notifications,
        } = this.props;

        if ( notifications.length === 0 ) {
            return (
                <ul className="menu">
                    <li>
                        <h4 className="text-center m-t-15 m-b-15">
                            {I18nUtils.tr('TR_NO_TIENES_NOTIFICACIONES')}
                        </h4>
                    </li>
                </ul>
            );
        }

        return (
            <ul className="menu notification-menu">
                {
                    notifications.map((notification) =>
                        <NotificationPreviewListItem
                            key={notification.id()}
                            notification={notification}
                        />
                    )
                }
            </ul>
        );
    }
}

NotificationPreviewList.propTypes = {
    notifications: PropTypes.array.isRequired,
};

NotificationPreviewList.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/preview-list/NotificationPreviewList.jsx